import router from '../router';
import userServ from '../services/user.service';

const getDefaultState = () => ({
    loggedIn: userServ.getToken() ? true : false,
    isManager: userServ.isManager(),
});

export const auth = {
    namespaced: true,

    state: getDefaultState(),

    mutations: {
        loginSuccess(state) {
            state.loggedIn = true;
        },
        logout(state) {
            state.loggedIn = false;
        },
        setIsManager(state, isManager) {
            state.isManager = isManager;
        },
        resetState(state) {
            Object.assign(state, getDefaultState());
        },
    },

    actions: {

        login({ commit, dispatch }, { email, password, recaptchaToken, isRetailer }) {
            userServ.login(email, password, recaptchaToken, isRetailer)
                .then(
                    () => {
                        commit('loginSuccess');
                        dispatch('message/info', { title: 'Login Successfully', content: 'Welcome !', sec: 2000 }, { root: true })
                        router.push('/');
                    },
                    () => {
                        commit('logout');
                    }
                )
        },

        logout({ commit }) {
            userServ.logout();
            commit('logout');
            if (router.currentRoute.path != '/login') {
                router.push('/login');
            }
        },

        checkRole({ commit }) {
            commit('setIsManager', userServ.isManager());
        },

    }

};